import { Worker } from "types/generated";

export const getAllItemsForSelectAll = (workers: Worker[]) =>
  new Set(workers.map((worker) => worker.id));
